import React from "react";

const Pill = ({
  text,
  width = "",
  styles = "",
  tooltipText = "",
  onClick,
  active = false,
  disabled = false,
}) => {
  const interactive = typeof onClick === "function" && !disabled;

  return (
    <button
      type="button"
      className={`pill-wrapper${active ? " pill-wrapper--active" : ""}${
        interactive ? " pill-wrapper--clickable" : ""
      }`}
      style={{ width: width || undefined, ...styles }}
      title={tooltipText}
      onClick={interactive ? onClick : undefined}
      disabled={disabled}
      aria-pressed={interactive ? active : undefined}
    >
      <span className="pill-text">{text}</span>
    </button>
  );
};

export default Pill;
